export const SETTINGS_ENDPOINTS = {
  userRoles: '/settings/user-roles',
  permissionLevels: '/settings/permission-levels',
  employmentTypes: '/settings/employment-types',
  functionalTeams: '/settings/functional-teams',
  skills: '/settings/skills',
  technologies: '/settings/technologies',
  predefinedQuestions: '/settings/predefinedQuestions',
  applicantStatuses: '/settings/applicantStatuses',
  institutes: '/settings/institutes',
} as const;
